import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import * as actions from './categoryActions';
import CategoryListContainer from './CategoryList/CategoryListContainer';
import CategoryDetailContainer from './CategoryDetail/CategoryDetailContainer';

const CategoryContainer = ({
  currentPage,
  getCategories,
  requestParams,
  loadCreateCategoryPage,
  loadListCategoryPage,
  updateCategoriesRequestParams,
}) => {
  const [searchString, setSearchString] = useState('');
  const [isSearching, setIsSearching] = useState(false);
  useEffect(() => {
    getCategories({
      ...requestParams,
      page_number: 1,
    });
    loadListCategoryPage();
    return () => {
      updateCategoriesRequestParams({
        ...requestParams,
        page_number: 1,
      });
      setSearchString('');
    };
  }, []);
  useEffect(() => {
    setIsSearching(true);
    const debounce = setTimeout(() => {
      const newRequestParams = {
        ...requestParams,
        page_number: 1,
        search_string: searchString,
      };
      if (searchString.length > 2 || searchString === '') {
        getCategories(newRequestParams);
      }
      updateCategoriesRequestParams(newRequestParams);
      setIsSearching(false);
    }, 1500);
    return () => {
      clearTimeout(debounce);
    };
  }, [searchString, currentPage]);
  if (currentPage === 'list') {
    return (
      <CategoryListContainer
        handleCreateButtonClick={() => loadCreateCategoryPage()}
        searchString={searchString}
        setSearchString={setSearchString}
        isSearching={isSearching}
      />
    );
  } else if (currentPage === 'create') {
    return <CategoryDetailContainer />;
  } else if (currentPage === 'edit') {
    return <CategoryDetailContainer isEdit={true} />;
  }
};

const mapStateToProps = (state) => ({
  currentPage: state.categoryReducer.currentPage,
  requestParams: state.categoryReducer.requestParams,
});

export default connect(mapStateToProps, actions)(CategoryContainer);
